import type { ReactNode } from 'react';

export const symbol_g_translate: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m481-80-41-120H160q-35 0-57.5-22.5T80-280v-520q0-35 22.5-57.5T160-880h240l35 119h365q35 0 57.5 22.5T880-681v521q0 35-22.5 57.5T800-80H481ZM287-376q69 0 113-45t44-116v-15.5q0-6.5-2-11.5H283v61h90q-8 29-30.5 45T288-442q-39 0-67-28.5T193-540q0-41 28-69.5t67-28.5q18 0 33.5 6.5T350-612l49-46q-20-22-50-34t-62-12q-68 0-115.5 48T124-540q0 68 47.5 116T287-376Zm267 19 23-21q-14-17-26-32.5T528-444l26 87Zm50-51q29-33 43.5-63t19.5-47H508l11 43h40q8 15 19 32t26 35Zm-83 288h279q17 0 28.5-11.5T840-160v-521q0-17-11.5-28.5T800-721H448l46 163h79v-43h41v43h147v40h-52q-9 38-29 74t-47 67l109 108-29 29-109-108-36 36 33 112-80 80Z"
		/>
	</svg>
);
